import React from 'react';

import GeneralProfile from './GeneralProfile';

export default function ProfileSettings() {
  return (
    <div className="profile-settings">
      <GeneralProfile />
    </div>
  );
}
